export default __webpack_public_path__ + "static/media/file.a4121490.svg";